import React from "react";
import "./LiveChartRead.css";

function LiveChartRead({
  symbol = "—",
  confidence = 0,
  trend = "Monitoring",
  priceStructure = "Waiting for chart structure",
  vwap = "Monitoring",
  ema20 = "Monitoring",
  macd = "Monitoring",
  volume = "Monitoring",
  support = "—",
  resistance = "—",

}) {
  const getConditionClass = (value = "") => {
    const normalizedValue = String(value).toLowerCase();

    if (
      normalizedValue.includes("bearish") ||
      normalizedValue.includes("below") ||
      normalizedValue.includes("weak") ||
      normalizedValue.includes("declining") ||
      normalizedValue.includes("failed")
    ) {
      return "liveChartReadDanger";
    }

    if (
      normalizedValue.includes("bullish") ||
      normalizedValue.includes("above") ||
      normalizedValue.includes("strong") ||
      normalizedValue.includes("increasing") ||
      normalizedValue.includes("confirmed")
    ) {
      return "liveChartReadPositive";
    }

    return "liveChartReadNeutral";
  };

  return (
    <div className="liveChartRead" data-tour-id="market-structure-analysis">
      <div className="liveChartReadHeader">
        <div>
          <span className="liveChartReadEyebrow">
            OBJECTIVE CHART ANALYSIS
          </span>

          <h3>🤖 AI Live Chart Read</h3>

          <p>{symbol} technical conditions</p>
        </div>

        <div className="liveChartReadConfidence">
          <span>Confidence</span>
          <strong>{confidence}%</strong>
        </div>
      </div>

      <div className="liveChartReadSummary">
        <span>Current Structure</span>
        <strong>{priceStructure}</strong>
        
      </div>

      <div className="liveChartReadConditions">
        <div>
          <span>Trend</span>
          <strong className={getConditionClass(trend)}>
            {trend}
          </strong>
        </div>

        <div>
          <span>VWAP</span>
          <strong className={getConditionClass(vwap)}>
            {vwap}
          </strong>
        </div>

        <div>
          <span>EMA 20</span>
          <strong className={getConditionClass(ema20)}>
            {ema20}
          </strong>
        </div>

        <div>
          <span>MACD</span>
          <strong className={getConditionClass(macd)}>
            {macd}
          </strong>
        </div>

        <div>
          <span>Volume</span>
          <strong className={getConditionClass(volume)}>
            {volume}
          </strong>
        </div>
      </div>

      <div className="liveChartReadLevels">
        <div>
          <span>Nearest Support</span>
          <strong>{support}</strong>
        </div>

        <div>
          <span>Nearest Resistance</span>
          <strong>{resistance}</strong>
        </div>
      </div>
    </div>
  );
}

export default LiveChartRead;